import React, {Suspense, useEffect, useRef, useState} from 'react';
import ModalWrapper from "./ModalWrapper";
import {useDispatch, useSelector} from "react-redux";
import {actionsState as projectState} from "../Redux/project";
import {getStrLang} from "../Helpers/functions";

const ShowHelp = ({floor})=>{


    const dispatch = useDispatch();

    const close = ()=>{
        dispatch(projectState.setModal(''));
    }

    useEffect(()=>{
    },[floor])

    return  <ModalWrapper
            title={ getStrLang('c3d_CNEUl') }
            onClose={()=>close()}
        >
            <div className="modal-body">
                <p>{ getStrLang('c3d_RasaG') } { getStrLang('c3d_wy1R6') }</p>
                <p>{ getStrLang('c3d_C0Vvg') }</p>
                <a target={'_blank'} href={'https://olissys.com/configurator3d/order/opros.php'} className="btn btn-default">{ getStrLang('c3d_EAKSh') }</a>
            </div>
        </ModalWrapper>
}

export default ShowHelp
